import { useAccountCompanyId } from 'application/hooks';

import useRemoveCard from 'domain/billing/useRemoveCard';

import { UseCardRemoveModalViewModel } from './types';

interface Props {
  showInfoNotification: () => void;
  showErrorNotification: () => void;
  close: () => void;
  afterClose?: () => void;
}

const useCardRemoveModalViewModel = ({
  showInfoNotification,
  showErrorNotification,
  close,
  afterClose,
}: Props): UseCardRemoveModalViewModel => {
  const companyId = useAccountCompanyId();

  const { request: removeCard, result: removeCardResult } = useRemoveCard();

  const removeCardSubmit = async () => {
    try {
      const isOk = await removeCard(companyId);

      if (isOk) {
        showInfoNotification();
        close();
        afterClose?.();
      }
    } catch (e) {
      showErrorNotification();
    }
  };

  return {
    removeCardSubmit,
    removeCardLoading: removeCardResult.loading,
  };
};

export default useCardRemoveModalViewModel;
